export enum CouponType {
    '门店券' = 1,
    '优惠券',
    '充值卡',
    '组合券',
    '公司、家庭卡' = 6,
    '会员券',
    '饭票券',
    '随心兑自制' = 10
}
